import { MethodPropertiesKey } from '../../shared/consts';
import { getIntervalsHandler } from './intervals-method-handlers';
import { MethodCommands, MethodHandler, MethodProperties } from '@lentau/analytics/health-metrics/shared';
export enum IntervalMethods {
  GetIntervals = 'userAddressDeliveryIntervalSearchsynced',
}
export const INTERVAL_HANDLER_LIST: MethodHandler = {
  [IntervalMethods.GetIntervals]: getIntervalsHandler,
};

export const INTERVAL_PROPERTIES_LIST: MethodProperties = new Map([
  [
    IntervalMethods.GetIntervals,
    [
      {
        key: MethodPropertiesKey.TEAM,
        value: MethodCommands.CH,
      },
    ],
  ],
]);
